import useTranslation from 'next-translate/useTranslation'
import { Button } from '@/components/Button'

export interface ErrorViewProps {
  onRetry: () => void
  onReset: () => void
}

export default function ErrorView({ onRetry, onReset }: ErrorViewProps) {
  const { t } = useTranslation('wertCheck')

  return (
    <div className="bg-static-white rounded-xl shadow-[0_0_2rem_rgba(0,0,0,0.1)] p-6 flex flex-col items-center gap-4 text-center">
      <p className="text-l text-primary">{t('error_message')}</p>

      <Button type="button" variant="cta" className="w-full" onClick={onRetry}>
        {t('error_retry')}
      </Button>

      <Button type="button" variant="link" onClick={onReset}>
        {t('reset')}
      </Button>
    </div>
  )
}
